import _objectSpread from "/home/runner/work/options_website/options_website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/runner/work/options_website/options_website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/options_website/options_website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/options_website/options_website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/options_website/options_website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/options_website/options_website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/runner/work/options_website/options_website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
var _excluded = ["style", "className", "fill", "paused", "children", "id", "svgId", "svgPathId", "d", "ref", "height", "amplitude", "speed", "points"],
    _excluded2 = ["options"];
import t, { Component as i } from "react";

function s() {
  return s = Object.assign ? Object.assign.bind() : function (t) {
    for (var i = 1; i < arguments.length; i++) {
      var s = arguments[i];

      for (var h in s) {
        Object.prototype.hasOwnProperty.call(s, h) && (t[h] = s[h]);
      }
    }

    return t;
  }, s.apply(this, arguments);
}

var h = /*#__PURE__*/function (_i) {
  _inherits(h, _i);

  var _super = _createSuper(h);

  function h(i) {
    var _this;

    _classCallCheck(this, h);

    _this = _super.call(this, i), _this.t = function () {
      return _this.i.current.offsetWidth;
    }, _this.h = function () {
      return _this.i.current.offsetHeight;
    }, _this.i = t.createRef(), _this.state = {
      path: ""
    }, _this.o = 0, _this.l = 0, _this.u = 0, _this.p = _this.p.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(h, [{
    key: "m",
    value: function m() {
      var t = [];

      for (var _i2 = 0; _i2 <= Math.max(this.props.points, 1); _i2++) {
        var _s = 100,
            _h4 = _i2 / this.props.points * this.t(),
            _e = (this.u + (_i2 + _i2 % this.props.points)) * this.props.speed * _s,
            _n = Math.sin(_e / _s) * this.props.amplitude,
            r = Math.sin(_e / _s) * _n + this.props.height;

        t.push({
          x: _h4,
          y: r
        });
      }

      return t;
    }
  }, {
    key: "v",
    value: function v(t) {
      var i = "M ".concat(t[0].x, " ").concat(t[0].y);

      var s = {
        x: (t[1].x - t[0].x) / 2,
        y: t[1].y - t[0].y + t[0].y + (t[1].y - t[0].y)
      },
          _h2 = function _h2(t, i) {
        return " C ".concat(t.x, " ").concat(t.y, " ").concat(t.x, " ").concat(t.y, " ").concat(i.x, " ").concat(i.y);
      };

      i += _h2(s, t[1]);
      var e = s;

      for (var _s2 = 1; _s2 < t.length - 1; _s2++) {
        e = {
          x: t[_s2].x - e.x + t[_s2].x,
          y: t[_s2].y - e.y + t[_s2].y
        }, i += _h2(e, t[_s2 + 1]);
      }

      return i += " L ".concat(this.t(), " ").concat(this.h()), i += " L 0 ".concat(this.h(), " Z"), i;
    }
  }, {
    key: "$",
    value: function $() {
      this.setState({
        path: this.v(this.m())
      });
    }
  }, {
    key: "g",
    value: function g() {
      if (!this.props.paused) {
        var _t = new Date();

        this.l += _t - this.o, this.o = _t;
      }

      this.u = this.l * Math.PI / 1e3, this.$();
    }
  }, {
    key: "p",
    value: function p() {
      this.g(), this.M && this._();
    }
  }, {
    key: "_",
    value: function _() {
      this.M = window.requestAnimationFrame(this.p), this.o = new Date();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.M || this._();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.cancelAnimationFrame(this.M), this.M = 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          i = _this$props.style,
          _h3 = _this$props.className,
          e = _this$props.fill,
          n = _this$props.paused,
          r = _this$props.children,
          a = _this$props.id,
          o = _this$props.svgId,
          d = _this$props.svgPathId,
          l = _this$props.d,
          c = _this$props.ref,
          u = _this$props.height,
          p = _this$props.amplitude,
          f = _this$props.speed,
          w = _this$props.points,
          m = _objectWithoutProperties(_this$props, _excluded);
      /*#__PURE__*/


      return t.createElement("div", {
        style: _objectSpread({
          width: "100%",
          display: "inline-block"
        }, i),
        className: _h3,
        id: a,
        ref: this.i
      }, /*#__PURE__*/t.createElement("svg", {
        width: "100%",
        height: "100%",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        id: o
      }, r, /*#__PURE__*/t.createElement("path", s({}, Object.assign({}, {
        d: this.state.path,
        fill: e
      }, m), {
        id: d
      }))));
    }
  }]);

  return h;
}(i);

var e = {
  fill: "#fff",
  paused: !1,
  height: 20,
  amplitude: 20,
  speed: .15,
  points: 3
},
    n = function n(i) {
  var s = i.options,
      n = _objectWithoutProperties(i, _excluded2);
  /*#__PURE__*/


  return t.createElement(h, Object.assign({}, e, s, n));
};

export { n as default };